function splitNumber(num) {
    
    
    // 特殊情况处理
    const specialCases = {
        10: [5, 5],
        11: [5, 6],
        12: [4, 4, 4],
        13: [4, 4, 5],
        14: [4, 5, 5],
        15: [7, 8],
        16: [8, 8],
        17: [5, 6, 6],
        18: [6, 6, 6],
        19: [6, 6, 7],
        20: [5, 5, 5, 5]
    };
    
    if (specialCases[num]) {
        return specialCases[num].join(',');
    }
    
    // 尝试不同的分组数量，找到最优解
    function tryPartition(n, count) {
        const baseValue = Math.floor(n / count);
        const remainder = n % count;
        let result = [];
        
        for (let i = 0; i < count; i++) {
            result.push(i < remainder ? baseValue + 1 : baseValue);
        }
        
        // 检查是否所有数字都在4-9之间
        return result.every(x => x >= 4 && x <= 9) ? result : null;
    }
    
    // 从最小可能的分组数开始尝试
    let minGroups = Math.ceil(num / 9); // 最少需要的组数
    let maxGroups = Math.ceil(num / 4); // 最多可能的组数
    
    for (let groupCount = minGroups; groupCount <= maxGroups; groupCount++) {
        const result = tryPartition(num, groupCount);
        if (result) {
            return result.sort((a, b) => a - b).join(',');
        }
    }
    
    // 如果上述方法都无法得到结果，使用之前的备选方案
    let result = [];
    let remaining = num;
    
    while (remaining > 0) {
        if (remaining <= 9) {
            result.push(remaining);
            break;
        } else {
            for (let i = 9; i >= 4; i--) {
                if (remaining - i >= 4 && Math.ceil((remaining - i) / 9) >= 1) {
                    result.push(i);
                    remaining -= i;
                    break;
                }
            }
        }
    }
    
    return result.sort((a, b) => a - b).join(',');
}

// 截取header元素
async function captureHeader() {
    const allCanvases = [];
    const header = document.getElementsByClassName('ep-header')[0];
    if (header) {
        try {
            // 创建临时容器
            const headerContainer = document.createElement('div');
            headerContainer.style.position = 'relative';
            headerContainer.style.width = '100%';
            headerContainer.style.backgroundColor = 'white';
            headerContainer.style.margin = '0';
            headerContainer.style.padding = '0';
            
            // 克隆header
            const headerClone = header.cloneNode(true);
            headerContainer.appendChild(headerClone);
            
            // 获取header高度
            const headerRect = header.getBoundingClientRect();
            headerContainer.style.height = headerRect.height + 'px';
            
            // 添加到文档
            document.body.appendChild(headerContainer);
            
            // 截取header
            const headerScreenshot = await html2canvas(headerContainer, {
                width: window.innerWidth,
                height: headerRect.height,
                windowWidth: window.innerWidth,
                windowHeight: headerRect.height,
                scrollY: 0,
                useCORS: true,
                allowTaint: true,
                backgroundColor: 'white',
                removeContainer: true
            });
            
            // 移除临时容器
            document.body.removeChild(headerContainer);
            
            // 处理并保存header图片
            const headerCanvas = document.createElement('canvas');
            const headerCtx = headerCanvas.getContext('2d');
            headerCanvas.width = headerScreenshot.width;
            headerCanvas.height = headerScreenshot.height;
            headerCtx.drawImage(headerScreenshot, 0, 0);
            
            // 去除底部空白
            const headerImageData = headerCtx.getImageData(0, 0, headerCanvas.width, headerCanvas.height);
            const headerData = headerImageData.data;
            let lastNonWhitePixel = headerCanvas.height;
            
            for (let y = headerCanvas.height - 1; y >= 0; y--) {
                let hasNonWhite = false;
                for (let x = 0; x < headerCanvas.width; x++) {
                    const index = (y * headerCanvas.width + x) * 4;
                    if (headerData[index] !== 255 || headerData[index + 1] !== 255 || headerData[index + 2] !== 255) {
                        hasNonWhite = true;
                        break;
                    }
                }
                if (hasNonWhite) {
                    lastNonWhitePixel = y + 1;
                    break;
                }
            }
            
            // 创建最终的header canvas
            const finalHeaderCanvas = document.createElement('canvas');
            finalHeaderCanvas.width = headerCanvas.width;
            finalHeaderCanvas.height = lastNonWhitePixel;
            const finalHeaderCtx = finalHeaderCanvas.getContext('2d');
            finalHeaderCtx.drawImage(headerScreenshot, 0, 0);
            
            // 将header canvas添加到数组中
            allCanvases.push(finalHeaderCanvas);
            
            // 等待一会儿再继续处理题目
            // await new Promise(resolve => setTimeout(resolve, 1000));
        } catch (error) {
            console.error('截取header失败:', error);
        }
    }
    return allCanvases;
}

// 截取题目分组
async function captureGroup(questions, startIndex, count) {
    // 获取第一个和最后一个元素
    const firstElement = questions[startIndex];
    const lastElement = questions[startIndex + count - 1];
    
    if (!firstElement || !lastElement) return null;

    try {
        // 创建一个临时容器
        const container = document.createElement('div');
        container.style.position = 'relative';
        container.style.width = '480px'; // 固定宽度
        container.style.backgroundColor = 'white';

        // 创建包装容器
        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        wrapper.style.top = '0';
        wrapper.style.margin = '0';
        wrapper.style.padding = '0';
        wrapper.style.maxWidth = '480px';

        // 复制元素及其之间的所有内容
        for (let i = startIndex; i < startIndex + count; i++) {
            const elementClone = questions[i].cloneNode(true);
            const contentDivs = elementClone.getElementsByClassName('content-div');
            for (const div of contentDivs) {
                div.style.maxWidth = '480px';
                div.style.width = '480px';
                div.style.boxSizing = 'border-box';
            }
            wrapper.appendChild(elementClone);
        }
        container.appendChild(wrapper);
        // 先插入DOM再获取高度
        document.body.appendChild(container);
        // 重新计算实际高度
        const height = container.offsetHeight;
        container.style.height = height + 'px';
        
        // 设置容器样式以确保正确渲染
        container.style.overflow = 'hidden';
        container.style.margin = '0';
        container.style.padding = '0';
        container.style.boxSizing = 'border-box';
        
        // 将容器临时添加到文档中
        document.body.appendChild(container);
        
        // 使用html2canvas截图
        const screenshot = await html2canvas(container, {
            width: 480,
            height: height,
            windowWidth: 480,
            windowHeight: height,
            scrollY: 0,
            useCORS: true,
            allowTaint: true,
            backgroundColor: 'white',
            removeContainer: true
        });

        // 移除临时容器
        document.body.removeChild(container);

        // 创建一个新的canvas来处理图片
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // 设置canvas尺寸与截图相同
        canvas.width = screenshot.width;
        canvas.height = screenshot.height;
        
        // 将截图绘制到canvas上
        ctx.drawImage(screenshot, 0, 0);
        
        // 获取图片数据
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        
        // 从底部向上查找非白色像素的位置
        let lastNonWhitePixel = canvas.height;
        for (let y = canvas.height - 1; y >= 0; y--) {
            let hasNonWhite = false;
            for (let x = 0; x < canvas.width; x++) {
                const index = (y * canvas.width + x) * 4;
                // 检查像素是否为白色（RGB都为255）
                if (data[index] !== 255 || data[index + 1] !== 255 || data[index + 2] !== 255) {
                    hasNonWhite = true;
                    break;
                }
            }
            if (hasNonWhite) {
                lastNonWhitePixel = y + 1;
                break;
            }
        }
        
        // 创建新的canvas，只包含非白色部分
        const finalCanvas = document.createElement('canvas');
        finalCanvas.width = canvas.width;
        finalCanvas.height = lastNonWhitePixel;
        const finalCtx = finalCanvas.getContext('2d');
        finalCtx.drawImage(screenshot, 0, 0);

        return finalCanvas;
    } catch (error) {
        console.error('截图失败:', error);
        return null;
    }
}

// 拼接图片
async function combineImages(allCanvases) {
    try {
        // 获取文件名
        const titleElement = document.getElementsByClassName('ep-title')[0];
        const fileName = titleElement ? titleElement.textContent.trim() : 'combined_result';
        
        // 计算总宽度和最大高度
        let totalWidth = 0;
        let maxGroupHeight = 0;
        const headerCanvas = allCanvases[0]; // header是第一个canvas
        const groupCanvases = allCanvases.slice(1); // 其余的是分组canvas
        
        // 计算分组部分的总宽度和最大高度
        for (const canvas of groupCanvases) {
            totalWidth += canvas.width;
            maxGroupHeight = Math.max(maxGroupHeight, canvas.height);
        }

        // 创建最终的canvas，添加间距
        const padding = 10; // 设置间距为10px
        const finalCanvas = document.createElement('canvas');
        finalCanvas.width = totalWidth; // 直接使用实际总宽度，不再与header宽度比较
        finalCanvas.height = headerCanvas.height + padding + maxGroupHeight + padding; // 添加上下间距
        const finalCtx = finalCanvas.getContext('2d');
        
        // 填充白色背景
        finalCtx.fillStyle = 'white';
        finalCtx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

        // 绘制header（居中）
        const headerX = (finalCanvas.width - headerCanvas.width) / 2;
        finalCtx.drawImage(headerCanvas, headerX, 0);

        // 横向拼接所有分组图片（在header下方padding像素处开始）
        let currentX = 0;
        for (const canvas of groupCanvases) {
            finalCtx.drawImage(canvas, currentX, headerCanvas.height + padding);
            currentX += canvas.width;
        }

        // 保存最终的拼接图片
        const link = document.createElement('a');
        link.download = `${fileName}.png`;
        link.href = finalCanvas.toDataURL();
        link.click();
    } catch (error) {
        console.error('拼接图片失败:', error);
    }
}

// 导出 processQuestions 函数
export async function printQuestions() {
    const questions = document.getElementsByClassName('ep-question');
    const questionCount = questions.length;
    
    if (questionCount === 0) {
        alert('页面中没有找到class为ep-question的元素');
        return;
    }
    
    const splitResult = splitNumber(questionCount);
    const groups = splitResult.split(',').map(num => parseInt(num));

    // 存储所有截图的canvas
    let allCanvases = await captureHeader();
    
    // 逐组截图
    let currentIndex = 0;
    for (let i = 0; i < groups.length; i++) {
        const canvas = await captureGroup(questions, currentIndex, groups[i]);
        if (canvas) {
            allCanvases.push(canvas);
        }
        currentIndex += groups[i];
    }

    // 拼接并保存图片
    await combineImages(allCanvases);
}

// function createCustomButton() {
//     // 创建容器
//     const container = document.createElement('div');
//     container.style.position = 'fixed';
//     container.style.top = '20px';
//     container.style.right = '20px';
//     container.style.zIndex = '9999';
//     container.style.backgroundColor = 'white';
//     container.style.padding = '10px';
//     container.style.borderRadius = '5px';
//     container.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
    
//     // 创建按钮
//     const button = document.createElement('button');
//     button.textContent = '计算题目分组并截图';
//     button.style.padding = '5px 10px';
//     button.style.backgroundColor = '#4CAF50';
//     button.style.color = 'white';
//     button.style.border = 'none';
//     button.style.borderRadius = '3px';
//     button.style.cursor = 'pointer';
    
//     // 添加点击事件
//     button.onclick = processQuestions;
    
//     // 组装界面
//     container.appendChild(button);
//     document.body.appendChild(container);

//     // 添加html2canvas脚本
//     const script = document.createElement('script');
//     script.src = 'https://html2canvas.hertzen.com/dist/html2canvas.min.js';
//     document.head.appendChild(script);
// }

// // 当页面加载完成后执行
// window.addEventListener('load', createCustomButton);
// 在文件顶部导入 html2canvas
import html2canvas from 'html2canvas';